export class ClsTercerosRecuperarPassword {
  public EmpresaID: number;
  public Correo: string;
}
